import { StatementType } from "./index.js";
import { isAlterValue, isColumnValue, isCommaToken, isDefaultValue, isDropValue, isLeftParentToken, isNewStatement, isRightParentToken, isSemicolonToken, isSetValue, isStringToken, isTableValue, matchAlterTableAlter } from "../helper.js";
import { isNextvalDefault } from "./default.expression.js";
//#region ../schema-sql-parser/dist/parser/statement/alter.table.alter.column.js
var AddIdentity = [[
	"ADD",
	"GENERATED",
	"ALWAYS",
	"AS",
	"IDENTITY"
], [
	"ADD",
	"GENERATED",
	"BY",
	"DEFAULT",
	"AS",
	"IDENTITY"
]];
var ColumnActionWords = [
	"ADD",
	"DROP",
	"OPTIONS",
	"RESET",
	"RESTART",
	"SET",
	"TYPE"
];
function alterTableAlterColumnParser(tokens, $pos) {
	const head = matchAlterTableAlter(tokens);
	const newStatement = isNewStatement(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isComma = isCommaToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const isString = isStringToken(tokens);
	const isAlter = isAlterValue(tokens);
	const isTable = isTableValue(tokens);
	const isDrop = isDropValue(tokens);
	const isColumn = isColumnValue(tokens);
	const isSet = isSetValue(tokens);
	const isDefault = isDefaultValue(tokens);
	const word = (pos) => {
		const token = tokens[pos];
		return token && isString(pos) && !token.quoted ? token.value.toUpperCase() : "";
	};
	const isWords = (pos, words) => words.every((value, index) => word(pos + index) === value);
	const isNextvalAt = (pos) => {
		let end = pos;
		while (end < tokens.length && !newStatement(end)) end++;
		return isNextvalDefault(tokens.slice(pos, end))(0);
	};
	const makesAutoIncrement = (pos) => isSet(pos) && isDefault(pos + 1) && isNextvalAt(pos + 2) || AddIdentity.some((words) => isWords(pos, words));
	const isColumnName = (pos) => isString(pos) && (!newStatement(pos) || ColumnActionWords.includes(word(pos + 1)));
	const length = head($pos.value);
	const name = tokens[$pos.value + length - 1].value;
	const ast = [];
	let depth = 0;
	let actionStart = true;
	$pos.value += length;
	while ($pos.value < tokens.length) {
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (actionStart && isAlter($pos.value) && !isTable($pos.value + 1)) {
			actionStart = false;
			$pos.value++;
			if (isColumn($pos.value)) $pos.value++;
			if (isColumnName($pos.value)) {
				if (makesAutoIncrement($pos.value + 1)) ast.push({
					type: StatementType.alterTableAlterColumnAutoIncrement,
					name,
					columnName: tokens[$pos.value].value
				});
				$pos.value++;
				if (isDrop($pos.value)) $pos.value++;
			}
			continue;
		}
		if (newStatement($pos.value)) break;
		actionStart = false;
		if (isLeftParent($pos.value)) depth++;
		else if (isRightParent($pos.value)) depth--;
		else if (depth === 0 && isComma($pos.value)) actionStart = true;
		$pos.value++;
	}
	return ast;
}
//#endregion
export { alterTableAlterColumnParser };
